import {
  IonButton,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonNote,
  IonPage,
  useIonAlert,
} from '@ionic/react'
import { useParams } from 'react-router-dom'
import { format, parseISO } from 'date-fns'

import Avatar from '../../components/avatar'
import Header from '../../components/header'
import { useCleanClientImportLoyaltyPoints } from './mutations'
import { useClientImport } from './queries'

function ClientImportDetailPage() {
  const { clientImportId } = useParams<{ clientImportId: string }>()
  const { data } = useClientImport(clientImportId)
  const cleanClientImportLoyaltyPoints = useCleanClientImportLoyaltyPoints()

  const [presentAlert] = useIonAlert()

  function handleClearLoyalty(objectId: string) {
    presentAlert({
      header: 'Clear Loyalty Points',
      message: 'This cannot be undone. Are you sure?',
      buttons: [
        'Cancel',
        {
          text: 'OK',
          handler: () => {
            if (clientImportId) {
              cleanClientImportLoyaltyPoints.mutate({ objectId })
            }
          },
        },
      ],
    })
  }

  if (data) {
    const { clientImport, stats } = data

    return (
      <IonPage>
        <IonHeader>
          <Header title="Client Import" btn={null} showMenu />
        </IonHeader>
        <IonContent>
          {data ? (
            <div className="ion-padding">
              <div className="ion-padding-vertical flex w-full items-center justify-between">
                <div className="flex items-center">
                  <Avatar user={clientImport.user}></Avatar>
                  <div className="ion-margin-start">
                    <p className="text-sm">Created By</p>
                    <p className="font-semibold">
                      {clientImport.user?.firstName}{' '}
                      {clientImport.user?.lastName}
                    </p>
                  </div>
                </div>
              </div>
              <IonList>
                <IonItem>
                  <IonLabel>Status</IonLabel>
                  <IonNote>{clientImport.status}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Created</IonLabel>
                  <IonNote>
                    {clientImport.createdAt
                      ? format(parseISO(clientImport.createdAt.iso), 'M/d/yyyy')
                      : ''}
                  </IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Clients</IonLabel>
                  <IonNote>{clientImport.clientCount ?? 0}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Progress</IonLabel>
                  <IonNote>{clientImport.clientProgressCount ?? 0}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Create Call List</IonLabel>
                  <IonNote>
                    {clientImport.createCallList ? 'True' : 'False'}
                  </IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>File Name</IonLabel>
                  <IonNote>{clientImport.filename}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Loyalty Point Count</IonLabel>
                  <IonNote>{stats.loyaltyPointCount}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Loyalty Point Lifetime Count</IonLabel>
                  <IonNote>{stats.loyaltyPointLifetimeCount}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Opt In</IonLabel>
                  <IonNote>{clientImport.optIn ? 'True' : 'False'}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Opt Out</IonLabel>
                  <IonNote>{clientImport.optOut ? 'True' : 'False'}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Tag</IonLabel>
                  <IonNote>{clientImport.tagName ?? 'N/A'}</IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Time (s)</IonLabel>
                  <IonNote>
                    {clientImport.timeMs
                      ? Math.round(clientImport.timeMs / 1000)
                      : ''}
                  </IonNote>
                </IonItem>
                <IonItem>
                  <IonLabel>Unsubscribe</IonLabel>
                  <IonNote>
                    {clientImport.unsubscribe ? 'True' : 'False'}
                  </IonNote>
                </IonItem>
              </IonList>
              <div className="ion-padding">
                <IonButton
                  onClick={() => handleClearLoyalty(`${clientImport.objectId}`)}
                  disabled={
                    (stats.loyaltyPointCount === 0 &&
                      stats.loyaltyPointLifetimeCount === 0) ||
                    clientImport.status === 'processing' ||
                    cleanClientImportLoyaltyPoints.isLoading
                  }
                >
                  Clear Loyalty
                </IonButton>
              </div>
            </div>
          ) : null}
        </IonContent>
      </IonPage>
    )
  }

  return <IonLoading isOpen message={'Loading outreach...'} />
}

export { ClientImportDetailPage }
